import { useState } from 'react'
import { C, font } from '../design'
import { getModelPref, setModelPref } from '../utils/modelPrefs'

// Small persisted Gemini/Sonnet switch — used wherever a facts-first analysis
// call lets the user pick which model runs it (personality, socionics, contradictions).
export default function ModelToggle({ prefKey, label }) {
  const [model, setModel] = useState(() => getModelPref(prefKey))

  const pick = (m) => {
    setModel(m)
    setModelPref(prefKey, m)
  }

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
      {label && (
        <span style={{ fontFamily: font.mono, fontSize: 9.5, color: C.textMuted, letterSpacing: '0.04em' }}>
          {label}
        </span>
      )}
      <div style={{ display: 'flex', borderRadius: 6, border: `1px solid ${C.border}`, overflow: 'hidden' }}>
        {[['sonnet', 'Sonnet'], ['gemini', 'Gemini']].map(([val, txt]) => (
          <button
            key={val}
            onClick={() => pick(val)}
            style={{
              padding: '3px 9px',
              border: 'none',
              cursor: 'pointer',
              fontFamily: font.mono,
              fontSize: 10,
              background: model === val ? C.silverGlow : 'transparent',
              color: model === val ? C.silverHi : C.textMuted,
              transition: 'all 0.15s',
            }}
          >
            {txt}
          </button>
        ))}
      </div>
    </div>
  )
}
